import request from 'request';
import { API_NODE, API_TOKEN, GATEWAY_API_KEY } from './config';

export const getRetiradasPendentes = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: API_TOKEN,
          'x-api-key': GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '3416a75f4cea9109507cacd8e2f2aefc'
        },
        uri: `${API_NODE}/returnProducts/pendingReturnProducts`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};